export const INSTAGRAM_USERNAME_FIELD = 'Instagram';
export const NO_ASSIGNMENT = 'No Assignment';
